const PageDeliveryMethodConfig = () => import('./PageDeliveryMethodConfig');

export default {
  name: 'delivery-method',
  path: ':id/delivery-method/:delivery_method_id',
  params: {
    id: null,
    delivery_method_id: null,
  },
  component: PageDeliveryMethodConfig,
  meta: {
    title: 'Gerenciar método de entrega',
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/logistic-providers/pages/delivery-method-config/routes.js